import React, { useEffect, useState } from "react";
import LayerAdmin from "../LayerAdmin";
import { toast } from "react-toastify";
import ButtonLoader from "../../zamzam/components/ButtonLoader";
import { useNavigate } from "react-router-dom";
import URL_MAPPING from "../../../routes/constants";
import { addMasterTableSync, getMasterTableSync,getStatusMaster } from "../api/report";

const MasterSync = () => {
  const [formData, setFormData] = useState({
    employee_id: "",
    endpoint: "",
    sales_office: "",
    channel: "",
  });
  const [loading, setLoading] = useState(false);
  const [invalidFields, setInvalidFields] = useState<string[]>([]);
  const [dropdown1, setDropdown1] = useState<
    { endpoint: string; name: string }[]
  >([]);
  const [dropdown2, setDropdown2] = useState<string[]>([]);
  const [dropdown3, setDropdown3] = useState<string[]>([]);
  const [status, setStatus] = useState<string | null>(null);

const [batchId, setBatchId] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getInputClass = (field: string) =>
    `w-full border px-3 py-2 rounded ${
      invalidFields.includes(field) ? "border-red-500" : ""
    }`;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const emptyFields = Object.entries(formData)
      .filter(([_, value]) => !value)
      .map(([key]) => key);

    setInvalidFields(emptyFields);

    if (emptyFields.includes("endpoint")) {
      toast.error("Please fill all required fields.");
      return;
    }

    const payload = new FormData();
    payload.append("employee_id", formData.employee_id);
    payload.append("endpoint", formData.endpoint);
    payload.append("sales_office", formData.sales_office);
    payload.append("channel", formData.channel);

    try {
      setLoading(true);
      const response = await addMasterTableSync(payload);
      if (!response) throw new Error("No data received");

      toast.success(response.message);
      setBatchId(response.batch_job_id);
    const responseStatus = await getStatusMaster(response.batch_job_id);
    setStatus(responseStatus.sync_jobs[0].status)
   
      
    } catch (error: any) {
      console.error("Failed to submit data:", error,{
        autoClose: false,
        closeOnClick: true,
        draggable: true,
      });
      if (error?.response?.status === 404) {
        toast.error("Please try again later",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else if (error?.response?.status === 500) {
        toast.error("Server error while submitting data",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) => toast.error(err.msg,{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          }));
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.",{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          });
        }
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        setLoading(true);
        const res = await getMasterTableSync();
        setDropdown1(res?.endpoints || []);
        setDropdown2(res?.sales_offices || []);
        setDropdown3(res?.channels || []);
      } catch (error: any) {
        console.error("Failed to submit data:", error);
        if (error?.response?.status === 404) {
          toast.error("Route not found, Please try again later");
        } else if (error?.response?.status === 500) {
          toast.error("Server error while submitting data");
        } else {
          const detail = error?.response?.data?.detail;
          if (Array.isArray(detail)) {
            detail.forEach((err) => toast.error(err.msg));
          } else {
            toast.error(
              detail?.msg || detail || "An unexpected error occurred."
            );
          }
        }
      } finally {
        setLoading(false);
      }
    };

    fetchDropdowns();
  }, []);

  return (
    <LayerAdmin>
      <div className="flex items-center px-5 pt-5 gap-3">
        <h3 className="text-xl font-bold text-gray-700">Master Data Sync</h3>
      </div>
      <form onSubmit={handleSubmit} className="p-4 lg:w-1/3 sm:w-full">
        <div className="my-2">
          <label className="block font-semibold mb-1">Endpoint *</label>
          <select
            name="endpoint"
            value={formData.endpoint}
            onChange={handleChange}
            className={getInputClass("endpoint")}
          >
            <option value="">Select Report Type</option>
            {dropdown1 &&
              dropdown1.map((item) => (
                <option key={item?.endpoint} value={item?.endpoint}>
                  {item.name}
                </option>
              ))}
          </select>
        </div>

        {formData.endpoint === "/CustomerMDSet?$format=json" && (
          <div className="my-2">
            <label className="block font-semibold mb-1">Sales Office</label>
            <select
              name="sales_office"
              value={formData.sales_office}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded"
            >
              <option value="">Select Report Type</option>
              {dropdown2 &&
                dropdown2.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
            </select>
          </div>
        )}
        {/* <label className="block font-semibold mb-1">Sales Office</label>
          <select
            name="sales_office"
            value={formData.sales_office}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          >
            <option value="">Select Report Type</option>
            {dropdown2 &&
              dropdown2.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
          </select>
        </div> */}

        {formData.endpoint === "/CustomerMDSet?$format=json" && (
          <div className="my-2">
            <label className="block font-semibold mb-1">Channel</label>
            <select
              name="channel"
              value={formData.channel}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded"
            >
              <option value="">Select Report Type</option>
              {dropdown3 &&
                dropdown3.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
            </select>
          </div>
        )}
        {/* <label className="block font-semibold mb-1">Channel</label>
          <select
            name="channel"
            value={formData.channel}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          >
            <option value="">Select Report Type</option>
            {dropdown3 &&
              dropdown3.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
          </select>
        </div> */}

        {formData.endpoint === "/EmployeeMDSet?$format=json" && (
          <div className="my-2">
            <label className="block font-semibold mb-1">Employee Id</label>
            <input
              type="text"
              name="employee_id"
              value={formData.employee_id}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded"
              placeholder="Role Id"
            />
          </div>
        )}

        {/* <input
            type="text"
            name="employee_id"
            value={formData.employee_id}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            placeholder="Role Id"
          /> */}
        {/* </div> */}

        <button
          type="submit"
          disabled={loading}
          className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600 flex items-center gap-2"
        >
          Sync Data {loading && <ButtonLoader />}
        </button>

        {status && (
          <>
          <div className="mt-4">
            <h3 className="text-lg font-semibold">Sync Status:</h3>
            <p>{status}</p>
          </div>
            <button
            type="button"
            onClick={async () => {
              if (batchId) {
                try {
            setLoading(true);
            const responseStatus = await getStatusMaster(batchId);
            setStatus(responseStatus.sync_jobs[0].status);
            toast.success("Status refreshed successfully.");
                } catch (error: any) {
            console.error("Failed to refresh status:", error);
            toast.error("Failed to refresh status. Please try again.");
                } finally {
            setLoading(false);
                }
              } else {
                toast.error("No batch ID available to refresh status.");
              }
            }}
            className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600 flex items-center gap-2 mt-4"
          >
            Refresh Status
          </button>
          </>
        )}
      
      </form>
    </LayerAdmin>
  );
};

export default MasterSync;
